import {mainQuery} from '@github-ui/react-core/future/main-query'

import {agentFinderAppBuilder} from '../config/app-builder'

import type {AgentFinderResponse} from '../types'

export const agentFinderRoute = agentFinderAppBuilder.createQueryRouteConfig('agentFinderRoute', {
  path: '/agentfinder',
  queries: [
    mainQuery<AgentFinderResponse>({
      queryDeps: ({pathname, searchParams}) => {
        const params = new URLSearchParams()

        const search = searchParams.get('search') || ''
        const page = searchParams.get('page') || '1'

        params.set('page', search ? '1' : page)
        if (search) params.set('search', search)

        // Resource types are comma-separated canonical media types. The Rails
        // boundary also accepts legacy labels in existing URLs.
        const type = searchParams.get('type') || ''
        if (type) params.set('type', type)

        const pathWithParams = params.toString() ? `${pathname}?${params.toString()}` : pathname

        return {pathname: pathWithParams}
      },
    }),
  ],
})
